import { defineComponent as n, openBlock as r, createBlock as a, unref as p, mergeProps as i, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconMediaStop",
  __name: "IconMediaStop",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (l, e) => (r(), a(p(s), i(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "M7 8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
